<template>
<div>
    <v-container fluid>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <div class="d-flex justify-end">
      <v-btn 
        color="brand onBrand--text"
        dark
        small
        class="mt-2,mb-2"
        style="margin-right:0.5em;border-radius:8px;margin-top:-7px"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>My Cart</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col cols="12" sm="4" md="4">
                    <p>
                        <v-icon color="error">*</v-icon><b>Child</b>
                    </p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="child" :items="child_list" item-text="learner" item-value="id" label="Child" outlined persistent-hint hint="Please Select Child" @change="getMycart()" />
                </v-col>
            </v-row>
            <table class="styled-table" v-if="studentDetails">
                <thead>
                    <tr>
                        <th>PRN</th>
                        <th>Student Name</th>
                        <th>Standard</th>
                        <th>Division</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="studentDetails">
                        <td>{{ studentDetails.registration_number }}</td>
                        <td>{{ studentDetails.learner_name }}</td>
                        <td>{{ studentDetails.standard }}</td>
                        <td>{{ studentDetails.division }}</td>
                    </tr>
                </tbody>
            </table>
        </v-card>

        <v-card class="box" v-if="cartItems!=''">
            <!-- Cart Items Table -->
            <v-data-table :headers="headersCart" id="my-table-id" :search="searchQuery" :items="cartItems" item-value="id" class="elevation-1 mytable">
                <template v-slot:top>
                    <v-toolbar flat class="toolbar">
                        <v-toolbar-title>Cart</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <!-- Search Box -->
                        <v-text-field v-model="searchQuery" append-icon="search" label="search" rounded class="search-bar" background-color="white" color="white" hide-details></v-text-field>
                        <!-- <v-text-field v-model="searchQuery" dense outlined placeholder="Search Orders" prepend-inner-icon="mdi-magnify" clearable class="search-bar"></v-text-field> Export to Excel Button -->
                        <v-btn color="white" @click="fnExcelReport('my-table-id', 'MyOrders')">
                            <v-icon left>mdi-file-excel</v-icon> Export
                        </v-btn>
                    </v-toolbar>
                </template>

                <template v-slot:[`item.item_image`]="{ item }">
                    <span v-if="item.image_file_path">
                        <v-icon color="blue" class="cursor-pointer" @click="viewImage(item.image_file_path)">
                            visibility
                        </v-icon>
                    </span>
                    <span v-else>--</span>
                </template>

                <template v-slot:[`item.quantity`]="{ item }">
                    <v-btn small icon color="blue" @click="updateQuantity(item,'remove')" :disabled="item.quantity <= 1">
                        <v-icon>mdi-minus</v-icon>
                    </v-btn>
                    <span>{{ item.quantity }}</span>
                    <v-btn small icon color="blue" @click="updateQuantity(item,'add')">
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </template>

                <template v-slot:[`item.total_price`]="{ item }">
                    <span>{{ item.total_price }}</span>
                </template>

                <!-- Delete Item -->
                <template v-slot:[`item.action`]="{ item }">
                    <v-icon color="red" @click="removeFromCart(item)">mdi-delete</v-icon>
                </template>

                <template v-slot:[`item.sizechart_file_path`]="{ item }">
                    <span v-if="item.image_file_path">
                        <v-icon color="blue" class="cursor-pointer" @click="viewImage(item.sizechart_file_path)">
                            visibility
                        </v-icon>
                    </span>
                    <span v-else>--</span>
                </template>
            </v-data-table>

            <!-- Total Price -->
            <v-row class="mt-4" align="center">
                <v-col cols="auto">
                    <v-btn class="button" type="submit" :loading="loader" color="warning" @click="dialog = true">
                        Add More Items
                    </v-btn>
                </v-col>

                <v-spacer></v-spacer>

                <v-col cols="auto">
                    <h4>Total: {{ calculateTotal }}</h4>
                </v-col>
            </v-row>

            <br>
            <v-card class="box">
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong> Order Delivery Option </strong>
                    </v-toolbar-title>
                </v-toolbar>

                <v-row justify="center" dense>
                    <v-col cols="12" sm="4" md="4">
                        <p>
                            <v-icon color="error">*</v-icon><b>Delivery Options</b>
                        </p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="deliveryOption" :items="deliveryOptionList" item-text="name" item-value="id" label="Select Delivery Option" outlined persistent-hint hint="Select Delivery Option" @change="changeDeloveryOption(selectedDeliveryOption)" />
                    </v-col>
                </v-row>
                <!-- Conditional Sections Based on Delivery Option -->
                <v-row class="mt-4" justify="center">
                    <!-- Home Delivery -->
                    <v-col v-if="deliveryOptionName == 'Home Delivery'" cols="12" sm="4">
                        <h4>Pickup From Home</h4>
                        <v-textarea label="My Address *" v-model="homeAddress" outlined required />
                        <v-text-field label="Pin" v-model="pinCode" outlined required />
                    </v-col>

                    <!-- Supplier Shop Pickup -->
                    <v-col v-if="deliveryOptionName == 'Supplier Shop'" cols="12" sm="7">
                        <v-row class="mt-4" justify="center">
                            <v-col cols="12" sm="8">
                                <h4>Order Details</h4>
                                <v-simple-table dense class="bordered-table">
                                    <thead>
                                        <tr>
                                            <th class="bold-header">Item</th>
                                            <th class="bold-header">Vendor</th>
                                            <th class="bold-header">Vendor Shop</th>
                                            <th class="bold-header">Address</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in supplierShopCartItems" :key="index">
                                            <td>{{ item.item }}</td>
                                            <td>{{ item.invvendor }}</td>
                                            <td>{{ item.vendorshop }}</td>
                                            <td>{{ item.vendorshop_address }}</td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>

                            </v-col>
                        </v-row>
                        <!-- <h4>Pickup From Shop</h4>
                        <v-select v-model="selectedShop" :items="filteredSupplierShopList" item-text="name" item-value="id" label="Supplier Shop" outlined dense required />
                        <v-textarea v-model="selectedShopDetails.address" label="Shop Address" outlined readonly />
                        <v-text-field v-model="selectedShopDetails.contact_email" label="Shop - Email" outlined dense />
                        <v-text-field v-model="selectedShopDetails.contact_mobile" label="Shop - Mobile" outlined dense />
                        <v-text-field v-model="selectedShopDetails.business_hours" label="Business Hours" outlined dense /> -->
                    </v-col>

                    <!-- School Pickup -->
                    <!-- <v-col v-if="deliveryOptionName == 'School Pickup'" cols="12" sm="4">
                        <h4>Pickup From School</h4>
                        <v-textarea label="School Address" outlined readonly />
                    </v-col> -->
                </v-row>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field label="Delivery Charges" v-model="totalDeliveryCharges" outlined readonly disabled />
                    </v-col>
                </v-row>

            </v-card>

            <v-card class="box" v-if="payment_data != null && selectedDeliveryOption">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Pay</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    Wallet Balance - {{ wallet_balance }} Rs.
                </v-toolbar>
                <br>
                <v-row justify="center" dense>
                    <!-- <v-col cols="12" sm="3" md="3">
                        <v-text-field label="Amount To Pay" v-model="faculty_canteen_fees" type="number" dense rounded readonly outlined hint="Please Enter Amount It's Rsequired"></v-text-field>
                    </v-col> -->
                    <form :action="url" @submit="payment" name="paytmform" method="POST">
                        <input type="hidden" :value="this.payment_data[0].orgid" name="orgid" />
                        <input type="hidden" :value="this.payment_data[0].tenantid" name="tenantid" />
                        <input type="hidden" :value="this.payment_data[0].uid" name="uid" />
                        <input type="hidden" :value="this.child" name="child" />
                        <input type="hidden" :value="prepareTransactionData" name="json_pre_trans_data" />
                        <input type="hidden" :value="calculateTotal+this.totalDeliveryCharges" name="fee_amount" />

                        <v-btn class="button" type="submit" :loading="loader" color="warning" :disabled="isProceedToPayDisabled">
                            Proceed to Pay
                        </v-btn>

                        <!-- <v-btn class="button" type="submit" :loading="loader" color="warning" :disabled="!selectedDeliveryOption" v-if="selectedDeliveryOption">Proceed to Pay</v-btn> -->
                    </form>
                    <v-btn class="button" type="submit" :loading="loader" color="warning" :disabled="isProceedToPayDisabled"  @click="payWithWallet()">
                        Pay With Wallet
                    </v-btn>
                    <marquee v-if="isWalletBalanceLow" class="low-balance-message">
                        Your wallet balance is insufficient to proceed. Please add funds to your wallet.
                    </marquee>
                </v-row>
            </v-card>
        </v-card>

        <!-- Dialog -->
        <v-dialog v-model="dialog" fullscreen>
            <v-card class="box">
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong> Add Items </strong>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn fab small color="white" outlined icon @click="dialog = false">
                        <v-icon> mdi-close </v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-row justify="center" dense>
                        <!-- Category Autocomplete -->
                        <v-col sm="2">
                            <v-icon color="error">*</v-icon>
                            <v-autocomplete color="#0F2027" dense rounded required v-model="itemCategory" :items="itemCategoryList" item-text="name" item-value="id" label="Category" outlined @change="filterItems" />
                        </v-col>
                    </v-row>

                    <br>
                    <v-card class="box" v-if="filteredItemList.length">
                        <v-data-table dense :headers="headersItems" :items="filteredItemList" item-value="id" class="elevation-1 mytable">

                            <template v-slot:[`item.item_image`]="{ item }">
                                <span v-if="item.image_file_path">
                                    <v-icon color="blue" class="cursor-pointer" @click="viewImage(item.image_file_path)">
                                        visibility
                                    </v-icon>
                                </span>
                                <span v-else>--</span>
                            </template>

                            <template v-slot:[`item.sizechart_file_path`]="{ item }">
                                <span v-if="item.image_file_path">
                                    <v-icon color="blue" class="cursor-pointer" @click="viewImage(item.sizechart_file_path)">
                                        visibility
                                    </v-icon>
                                </span>
                                <span v-else>--</span>
                            </template>

                            <template v-slot:[`item.select`]="{ item }">
                                <v-checkbox v-model="item.selected" />
                            </template>

                            <template v-slot:[`item.quantity`]="{ item }">
                            <v-text-field rounded outlined type="number" dense v-model="item.quantity" 
                            @input="updateTotalPrice(item)"
                            :rules="[
                                value => value > 0 || 'Quantity must be greater than 0',
                                value => value <= item.availableStockQuantity || `Only ${item.availableStockQuantity} items available`
                            ]" />
                        </template>

                            <template v-slot:[`item.total_price`]="{ item }">
                                <span>{{ item.total_price }}</span>
                            </template>

                        </v-data-table>
 
                        <v-row class="mt-4" align="center">
                            <v-col cols="4" class="text-center"></v-col>
                            <v-col cols="2" class="text-center">
                                <v-btn color="primary" :loading="loader" :disabled="isAddToCartDisabled" @click="addItemToCart">Add To Cart</v-btn>
                            </v-col>
                            <v-col cols="2" class="text-center"></v-col>
                            <v-col cols="2" class="text-right">
                                <h4>Total: {{ calculateTotal }}</h4>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
     <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span style="color:black">My Cart Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/unREE0kXmvI?si=Q3jisuK4y1iPIgXa"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
</div> <!-- /. root div -->
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
        itemCategoryList: [],
        itemCategory: "",
        videoDialog:false,
        filteredItemList: [], // Filtered list of items based on category
        itemList: [],
        dialog: false, // Controls the dialog visibility
        searchQuery: "", // For search functionality
        basepath: null,
        wallet_balance: 0,
        deliveryOptionList: [],
        deliveryOption: "",
        deliveryOptionName: "",
        homeAddress: '',
        pinCode: '',
        supplierShopList: [],
        selectedShop: "",
        wallet_grace_amount:'',
        loader: false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        overlay: false,
        child_list: [],
        child: "",
        studentDetails: null,
        cartItems: [],
        headersCart: [{
                text: "S.No",
                value: "srno"
            },
            {
                text: "Item Category",
                value: "itemcategory"
            },
            {
                text: "Item Name",
                value: "name"
            },
            {
                text: "Item Image",
                value: "item_image"
            },
            {
                text: "Item Description",
                value: "description"
            },
            {
                text: "Size Label",
                value: "sizelabel"
            },
            {
                text: "Size Chart",
                value: "sizechart_file_path"
            },
            {
                text: "Size Description",
                value: "sizechart_description"
            },
            {
                text: "Unit Price",
                value: "price"
            },
            {
                text: "Quantity",
                value: "quantity"
            },
            {
                text: "Total Price",
                value: "total_price"
            },
            {
                text: "Action",
                value: 'action',
                align: 'center',
                sortable: false
            } // Correct alignment and key for action column
        ],
        headersItems: [
            //{
            //     text: "S.No",
            //     value: "srno"
            // },
            {
                text: "Item Type",
                value: "itemcategory"
            },
            {
                text: "Item Name",
                value: "name"
            },
            {
                text: "Item Image",
                value: "item_image"
            },
            {
                text: "Item Description",
                value: "description"
            },
            {
                text: "Size Label",
                value: "sizelabel"
            },
            {
                text: "Size Chart",
                value: "sizechart_file_path"
            },
            {
                text: "Unit Price",
                value: "price"
            },
            {
                text: "Select",
                value: "select"
            },
            {
                text: "Quantity",
                value: "quantity"
            },
            {
                text: "Available Quantity",
                value: "availableStockQuantity"
            },
            {
                text: "Total Price",
                value: "total_price"
            },
        ],
    }),
    methods: {
        addItemToCart() {
            this.loader = true
            // Prepare payload directly from filteredItemList
            const payload = {
                itemIds: this.filteredItemList.filter(item => item.selected).map(item => item.id),
                quantities: this.filteredItemList.filter(item => item.selected).map(item => item.quantity),
                prices: this.filteredItemList.filter(item => item.selected).map(item => item.price),
                total_price: this.filteredItemList.filter(item => item.selected).map(item => item.total_price),
                child: this.child
            };

            this.overlay = true;
            axios.post("/EduStore/addItemsToCart", payload)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.cartItems = res.data.cartItems; // Store response in cartItems
                        this.showSnackbar("green", "Item Added Scuuessfully");
                    } else if (res.data.flag === "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.onerror(error);
                })
                .finally(() => {
                    this.overlay = false;
                    this.loader = false;
                });
        },
        updateTotalPrice(item) {
            if (item.total_price === undefined) {
                this.$set(item, 'total_price', 0); // Ensure reactivity
            }
            if (item.quantity > item.availableStockQuantity) {
                this.$toast.error(`Only ${item.availableStockQuantity} items are available in stock.`); // Show error message
                item.quantity = item.availableStockQuantity; // Reset to available stock
            }

            item.total_price = item.price * item.quantity; // Update the total price for the item
        },
        filterItems() {
            if (this.itemCategory) {
                this.filteredItemList = this.itemList.filter(item => item.itemcategoryId === this.itemCategory);
            } else {
                this.filteredItemList = this.itemList;
            }
        },
        fnExcelReport(id, name) {
            var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
            tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
            tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
            tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
            tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
            tab_text = tab_text + "<table border='1px'>";
            var exportTable = $("#" + id).clone();
            exportTable.find("input").each(function (index, elem) {
                $(elem).remove();
            });
            tab_text = tab_text + exportTable.html();
            tab_text = tab_text + "</table></body></html>";
            var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";
            const blob = new Blob([tab_text], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const filename = name + '.xls';

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        viewImage(imagePath) {
            if (imagePath) {
                const fullImageUrl = `${this.basepath}${imagePath}`;
                window.open(fullImageUrl, "_blank");
            } else {
                console.warn("No image path provided.");
            }
        },
        payWithWallet() {
            if (!confirm("Are You Sure You Want To Pay With Wallet...?")) return;
            if (this.wallet_balance+this.wallet_grace_amount <= 0) {
                this.showSnackbar("red", "Insufficient Balance Wallet...Please Recharge Your Wallet...");
                return;
            }
            if (this.wallet_balance+this.wallet_grace_amount < this.calculateTotal + this.totalDeliveryCharges) {
                this.showSnackbar("red", "Insufficient Balance Wallet To Complete This Order...Please Recharge Your Wallet...");
                return;
            }
            const data = {
                child: this.child,
                json_pre_trans_data: this.prepareTransactionData,
                total_value: this.calculateTotal + this.totalDeliveryCharges
            };
            this.overlay = true;
            axios.post("/EduStore/payWithWallet", data)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.showSnackbar("green", "Order Placed Successfully...");
                    } else if (res.data.flag === "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                    this.getMycart();
                });
        },
        updateQuantity(item, type) {
            if (!confirm("Are You Sure You Want To Update Cart...?")) return;
            const data = {
                cartId: item.id,
                child: this.child,
                type: type
            };
            this.overlay = true;
            axios.post("/EduStore/updateCartQuantity", data)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.cartItems = res.data.cartItems; // Store response in cartItems
                        this.showSnackbar("green", "Updated Successfully...");
                    } else if (res.data.flag === "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                    this.calculateTotal();
                });
        },
        changeDeloveryOption(item) {
            this.deliveryOptionName = item.name
            if (this.deliveryOptionName === "Home Delivery" && this.studentDetails.local_address) {
                this.homeAddress = this.studentDetails.local_address;
            } else if (this.deliveryOptionName === "School Pickup" && this.studentDetails.schol_address) {
                this.homeAddress = this.studentDetails.schol_address;
            } else {
                this.homeAddress = ""; // Clear address when another option is selected
            }
        },
        payment() {
            this.loader = true
            var formData = new FormData(paytmform);
            this.pg_loader = false;
        },
        getSelectedAddress() {
            if (this.deliveryOptionName === 'Home Delivery') {
                return this.homeAddress;
            } else if (this.deliveryOptionName === 'Supplier Shop') {
                return this.selectedShopDetails.address;
            } else if (this.deliveryOptionName === 'School Pickup') {
                return this.homeAddress;; // Replace with actual school address if needed
            }
            return '';
        },
        removeFromCart(item) {
            //const index = this.cartItems.findIndex(cartItem => cartItem.id === item.id);
            // if (index !== -1) {
            //     this.cartItems.splice(index, 1); // Remove item from cart
            // }
            if (!confirm("Are You Sure You Want To Remove Item From Cart...?")) return;
            const data = {
                cartId: item.id,
                child: this.child
            };
            this.overlay = true;
            axios.post("/EduStore/removeItemFromCart", data)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.cartItems = res.data.cartItems; // Store response in cartItems
                        this.showSnackbar("green", "Removed Successfully...");
                    } else if (res.data.flag === "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        getMycart() {
            const data = {
                child: this.child
            };
            this.overlay = true;
            axios.post("/EduStore/getMycart", data)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.cartItems = res.data.cartItems
                        this.studentDetails = {
                            registration_number: res.data.registration_number,
                            learner_name: res.data.learner_name,
                            standard: res.data.standard,
                            division: res.data.division,
                            local_address: res.data.local_address,
                            schol_address: res.data.schol_address
                        };
                        this.deliveryOptionList = res.data.deliveryOptionList;
                        this.supplierShopList = res.data.supplierShopList;
                        this.payment_data = res.data.payment_data
                        this.wallet_balance = res.data.wallet_balance,
                            this.itemList = res.data.itemList;
                        this.itemCategoryList = res.data.itemCategoryList;
                        this.wallet_grace_amount=res.data.wallet_grace_amount;
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        onLoad() {
            axios.post("ParentTransport/applyTransportFacility")
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.child_list = res.data.learner_list;
                    } else {
                        this.showSnackbar("#b71c1c", res.data.status_reason);
                    }
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    mounted() {
        this.onLoad();
        this.basepath = localStorage.getItem("awspath");
    },
    computed: {
        supplierShopCartItems() {
            return this.deliveryOptionName === 'Supplier Shop' ?
                this.cartItems.map(item => ({
                    item: item.name,
                    invvendor: item.invvendor,
                    vendorshop: item.vendorshop || 'N/A',
                    vendorshop_address: item.vendorshop_address || 'N/A',
                })) : [];
        },
        isAddToCartDisabled() {
            const isTotalInvalid = this.calculateTotal <= 0;
            const hasInvalidQuantity = this.filteredItemList.some(item =>
                item.selected && (
                    !item.quantity || item.quantity <= 0 || 
                    item.availableStockQuantity <= 0  // Ensure stock is available
                )
             );
             return isTotalInvalid || hasInvalidQuantity;
        },
        filteredSupplierShopList() {
            if (this.deliveryOptionName != 'Supplier Shop') {
                return this.supplierShopList;
            }
            const cartVendorIds = new Set(this.cartItems.map(item => item.invvendorId));
            return this.supplierShopList.filter(shop => cartVendorIds.has(shop.invvendorId));
        },
        calculateTotal() {
            let total = this.cartItems.reduce((sum, item) => sum + item.total_price, 0);
            return total;
        },
        selectedDeliveryOption() {
            // Find full object based on selected ID
            return this.deliveryOptionList.find(option => option.id === this.deliveryOption) || {};
        },
        selectedShopDetails() {
            // Find shop details based on selected ID
            return this.supplierShopList.find(shop => shop.id === this.selectedShop) || {};
        },
        isProceedToPayDisabled() {
            const selectedAddress = this.getSelectedAddress();
            return !selectedAddress || this.cartItems.length === 0 || !this.deliveryOptionName;
        },
        prepareTransactionData() {
            return JSON.stringify({
                totalAmount: this.calculateTotal,
                items: this.cartItems.map(item => ({
                    id: item.itemId,
                    quantity: item.quantity,
                    total_price: item.total_price
                })),
                address: this.getSelectedAddress(),
                deliveryOption: this.deliveryOption
            });
        },
        totalDeliveryCharges() {
            let uniqueVendors = new Set();
            let totalCharges = 0;

            this.cartItems.forEach((item) => {
                if (!uniqueVendors.has(item.invvendorId)) {
                    uniqueVendors.add(item.invvendorId);
                    totalCharges += item.delivery_charges;
                }
            });

            return totalCharges;
        },
        isWalletBalanceLow() {
            const totalCartCost = this.calculateTotal + this.totalDeliveryCharges;
            return this.wallet_balance < totalCartCost;
        }
    },
    watch: {},
    created() {
        this.url = process.env.VUE_APP_API_URL + "/paymentGatewayPayTM/paytmEduStoreOrder";
    },
};
</script>

<style scoped>
.search-bar {
    max-width: 450px;
    margin-right: 70px;
}

.search-bar input {
    color: white !important;
}

.search-bar input::placeholder {
    color: rgba(200, 32, 32, 0.8) !important;
    /* Adjust opacity for better visibility */
}

.search-bar .v-icon {
    color: white !important;
}

.export-btn {
    background-color: #4CAF50;
    color: white;
}

.cursor-pointer {
    cursor: pointer;
}

.styled-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    font-size: 14px;
}

.styled-table th,
.styled-table td {
    text-align: center;
    padding: 12px;
    border: 1px solid #ddd;
}

.styled-table th {
    background-color: #0f0464;
    color: white;
    font-weight: bold;
}

.styled-table tr:nth-child(even) {
    background-color: #f9f9f9;
}

.styled-table tr:hover {
    background-color: #f1f1f1;
}
.bordered-table {
    border: 1px solid #ddd; /* Table border */
    border-collapse: collapse;
    width: 100%;
}

.bordered-table th, 
.bordered-table td {
    border: 1px solid #ddd; /* Cell borders */
    padding: 8px;
    text-align: left;
}

.bold-header {
    font-weight: bold;
    background-color: #f5f5f5; /* Light gray background for headers */
}
</style>
